<template>
  <div style="display: flex;align-items: center;">
    <scale-group-select
      v-model="localValue"
      :disabled="!isFieldAvailableForEdit(scope.row, 'scale.template_id')"
      :current-scale="scope.row.scale.template"
      style="flex: 1 1 auto; margin-right: 5px; overflow: hidden"
      @change="saveElementPropChange(scope.row, 'scale', {template_id:$event})"
    >
    </scale-group-select>

    <!--      <el-popover-->
    <!--        style="margin-top:2px;"-->
    <!--        placement="top"-->
    <!--        title="Описание"-->
    <!--        width="400"-->
    <!--        trigger="click"-->
    <!--      >-->
    <!--        <el-button-->
    <!--          slot="reference"-->

    <!--          class="table-action-button open-desc-button"-->
    <!--          :class="{'has-desc': !!description}"-->
    <!--          type="text"-->
    <!--          round-->
    <!--          size="mini"-->
    <!--          icon="fas fa-info-circle"-->
    <!--        ></el-button>-->
    <!--        <div style="white-space: pre-line">{{description ? description : 'Нет описания для шкалы'}}</div>-->
    <!--      </el-popover>-->


    <el-tooltip
      v-if="scope.row.scale.template && $companyConfiguration.scales.getConfigurableScaleSettingsTemplate(scope.row.scale.template.type)"
      content="Детали шкалы"
      placement="top"
      :open-delay="500"
    >
      <el-button
        class="table-action-button open-desc-button"
        :class="{'has-desc': !!description}"
        type="text"
        round
        size="mini"
        icon="fas fa-info-circle"
        @click="$refs.editScaleDialog.open(scope.row)"
      ></el-button>
    </el-tooltip>


<!--    <el-popover-->
<!--      style="margin-top:2px;"-->
<!--      placement="top"-->
<!--      title="Описание"-->
<!--      width="400"-->
<!--      trigger="hover"-->
<!--      open-delay="500"-->
<!--    >-->

<!--      <div style="white-space: pre-line">{{description ? description : 'Нет описания для шкалы'}}</div>-->

<!--      <el-button-->
<!--        v-if="scope.row.scale.template && $companyConfiguration.scales.getConfigurableScaleSettingsTemplate(scope.row.scale.template.type)"-->
<!--        slot="reference"-->
<!--        :class="{'has-desc': !scopesEditDisabled}"-->
<!--        type="text"-->
<!--        :disabled="!scope.row.scale.template"-->
<!--        size="mini"-->
<!--        @click="$refs.editScaleDialog.open(scope.row)"-->
<!--      >-->
<!--        Детали шкалы-->
<!--      </el-button>-->
<!--    </el-popover>-->

    <cian-card-element-configurable-scale-edit-dialog
      ref="editScaleDialog"
      :disabled="scopesEditDisabled"
      @close="$emit('elements-changed');"
    >
    </cian-card-element-configurable-scale-edit-dialog>

  </div>
</template>

<script>


import { ElementPropTableColumn } from "@/mixins/elementPropTableColumn";
import CianCardElementConfigurableScaleEditDialog
  from "@/componentsCompany/cian/scales/CianCardElementConfigurableScaleEditDialog.vue";
import ScaleGroupSelect from "@/components/configurableScales/ScaleGroupSelect.vue";

export default {
  name: "cian-element-configurable-scale-table-column",
  components: { CianCardElementConfigurableScaleEditDialog, ScaleGroupSelect },
  mixins: [ElementPropTableColumn],

  props: {},
  computed: {
    description() {
      return this.scope.row?.scale?.template?.description;
    },
    scopesEditDisabled() {
      if (!this.isFieldAvailableForEdit(this.scope.row, "scale.scopes")) {
        return true;
      }
      if (!this.scope.row?.scale?.template?.allow_scopes_edit_in_element) {
        return true;
      }
      return false;
    }
  },
  data() {
    return {
      localValue: null
    };
  },
  watch: {
    "scope.row.scale.template": function(newVal) {
      this.localValue = this.scope.row.scale.template.id;
    }
  },
  mounted() {
    if (this.scope.row.scale.template) {
      this.localValue = this.scope.row.scale.template.id;
    }
  }
};

</script>

<style scoped lang="scss">
@import "@/assets/css/project-variables";

.open-desc-button {
  color: gray;

  &.has-desc {
    color: $--color-primary;
  }
}
</style>
